// UI translations. Source of truth is strings.json — a flat map of
//   { "key": { en, es, ca, fr }, ... }
// pivoted to T[lang][key] for fast lookup. Same shape as backend/app/i18n.py,
// so the two can be eyeballed side by side. Missing keys fall back to English.
import STRINGS from "./strings.json";

export const T = {};
for (const [key, langs] of Object.entries(STRINGS)) {
  for (const [lang, text] of Object.entries(langs)) {
    (T[lang] ||= {})[key] = text;
  }
}
